import { Alert, Typography } from '@mui/material'

import { Box } from '@/components/ui'

import type { FlagChangeSummary } from '../../utils/summarizeFlagChanges'

const DOWNGRADE_WARNING =
  'Switching a product flag off takes it away from the practice immediately.'

interface ChangeListProps {
  heading: string
  labels: string[]
}

const ChangeList = ({ heading, labels }: ChangeListProps) => {
  if (labels.length === 0) {
    return null
  }

  return (
    <Box variant='flexColumn' gap='xs'>
      <Typography variant='subtitle2'>{heading}</Typography>
      {labels.map((label) => (
        <Typography key={label} variant='body2' color='text.secondary'>
          {label}
        </Typography>
      ))}
    </Box>
  )
}

export interface SaveFlagsConfirmationProps {
  changes: FlagChangeSummary
}

/**
 * What the save is about to do, named flag by flag.
 *
 * Selecting a lower package stages everything above it off, so a confirmation that only
 * asked "are you sure" could hand over a downgrade the operator never intended. Listing
 * the product flags is the point of asking at all.
 */
export const SaveFlagsConfirmation = ({ changes }: SaveFlagsConfirmationProps) => {
  const { enabling, disabling, accountSidChanged } = changes

  return (
    <Box variant='flexColumn' gap='md'>
      {disabling.length > 0 && <Alert severity='warning'>{DOWNGRADE_WARNING}</Alert>}

      <ChangeList heading='Turning on' labels={enabling} />
      <ChangeList heading='Turning off' labels={disabling} />

      {accountSidChanged && (
        <Box variant='flexColumn' gap='xs'>
          <Typography variant='subtitle2'>Updating</Typography>
          <Typography variant='body2' color='text.secondary'>
            Twilio account SID
          </Typography>
        </Box>
      )}
    </Box>
  )
}
